import * as Yup from "yup";
import { ReajustePrevistoRealizado } from "./model";

export class ReajusteSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um maior que zero");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      tipo,
      anoMesReferencia,
      percentual,
      previstoRealizado,
    } = recordShape;

    const createFormShape = {
      tipo,
      anoMesReferencia,
      percentual,
      previstoRealizado,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      tipo,
      anoMesReferencia,
      percentual,
      previstoRealizado,
    } = recordShape;

    const updateFormShape = {
      tipo,
      anoMesReferencia,
      percentual,
      previstoRealizado,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  tipo: Yup.string(),
  anoMesReferencia: Yup.string(),
  percentual: Yup.number(),
  previstoRealizado: Yup
    .mixed<ReajustePrevistoRealizado>().oneOf(Object.values(ReajustePrevistoRealizado), `Previsto/Realizado deve ser "${Object.values(ReajustePrevistoRealizado).join('" ou "')}"`)
    .required("Previsto/Realizado é obrigatório"),
};
